document.addEventListener("DOMContentLoaded", function () {
    var cartCount = parseInt(document.querySelector(".cartCount")?.textContent || "0", 10);

    // if (cartCount > 1) {
    //     document.body.classList.add("hide-upsell");
    // }
});
